import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface CapacitacionActividadEjecucionPayload {
  id_actividad: number;
  observaciones?: string;
}

/**
 * 🔹 Interface de respuesta
 */
export interface CapacitacionActividadEjecucion {
  id?: number;
  id_actividad: number;
  observaciones?: string | null;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface CapacitacionActividadEjecucionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class CapacitacionActividadEjecucionService {
  private readonly apiUrl = `${environment.apiUrl}/api/capacitacion_actividad_ejecucion`;

  constructor(private http: HttpClient) {}

  // Listar todas las ejecuciones de actividades
  getAll(): Observable<CapacitacionActividadEjecucion[]> {
    return this.http.get<CapacitacionActividadEjecucion[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<CapacitacionActividadEjecucion> {
    return this.http.get<CapacitacionActividadEjecucion>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva ejecución de actividad
  create(payload: CapacitacionActividadEjecucionPayload): Observable<CapacitacionActividadEjecucionResponse> {
    return this.http.post<CapacitacionActividadEjecucionResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar ejecución de actividad
  update(id: number, payload: Partial<CapacitacionActividadEjecucionPayload>): Observable<CapacitacionActividadEjecucionResponse> {
    return this.http.put<CapacitacionActividadEjecucionResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar ejecución de actividad (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

    // Inactivar actividad de capacitación
    inactivar(id: number): Observable<CapacitacionActividadEjecucionPayload> {
      return this.http.put<CapacitacionActividadEjecucionPayload>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
    }
  
    // Activar actividad de capacitación
    activar(id: number): Observable<CapacitacionActividadEjecucionPayload> {
      return this.http.put<CapacitacionActividadEjecucionPayload>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
    }
}